<div
  fxLayout="row"
  fxLayoutAlign="start center"
  fxLayoutGap="16px"
  class="template-selector-container">
  <mat-form-field class="no-bottom-space" appearance="outline" fxFlex>
    <mat-label>{{ label() | translate }}</mat-label>
    <mat-select
      [formControl]="templateControl"
      [compareWith]="compareTemplates"
      (blur)="onTouched()"
      (focus)="onTouched()"
      data-testid="template-select">
      @if (documentTemplates$ | async; as templates) {
        @if (templates.length === 0) {
          <mat-option [value]="null" disabled>
            {{ 'GNR_NO_TEMPLATES_AVAILABLE' | translate }}
          </mat-option>
        } @else {
          @for (template of templates; track template._id) {
            <mat-option [value]="template">
              {{ template.name }}
            </mat-option>
          }
        }
      }
    </mat-select>
    @if (templateControl.hasError('required')) {
      <mat-error [control]="templateControl" />
    }
  </mat-form-field>
  <ng-template
    [qtPermission]="PermissionType.Update"
    [qtPermissionFeature]="feature()">
    <button
      mat-button
      class="toolbar-action-btn"
      type="button"
      [disabled]="disabled()"
      (click)="openCreateTemplateDialog()">
      {{ 'GNR_CREATE_TEMPLATE' | translate }}
    </button>
  </ng-template>
</div>

@if (documentTemplates$ | async; as templates) {
  @if (templates.length === 0 && templateType() === 'docs' && !required()) {
    <div class="template-empty-hint" aria-live="polite">
      {{ 'GNR_NO_TEMPLATES_HINT' | translate }}
    </div>
  }
}
